export default "__VITE_ASSET__KzR3MGtf__"